import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {LoginService} from "../../../app.services/login";
import {UserContextService} from "../../../app.services/user.context";
import {CredentialsCache} from "../../../common";

@Injectable()
export class LogoutProvider{
	private isDuringForcedLogout:boolean;

	constructor(private  router:Router, private loginSvc:LoginService,  private credentialsContainer:CredentialsCache){}

	public logout(force:boolean) {

		//Save the token info to session storage as ready for invalidation;
		this.credentialsContainer.saveToSessionStorage();

		this.isDuringForcedLogout=force;
		if (force){
			this.loginSvc.clearLoginInfo();
		}

		this.router.navigateByUrl("/")
			.then(() => {
				//If the user decides to abort logout we want to delete the saved session token
				setTimeout(() => {
					this.credentialsContainer.clearSessionStorage();
				}, 10000);
			});
	}

	public cancelLogout(){
		this.isDuringForcedLogout=false;
	}

	public duringForcedLogout(){
		return this.isDuringForcedLogout;
	}
}
